import { render, staticRenderFns } from "./TextInformationBox.vue?vue&type=template&id=c6e9a0a8&scoped=true"
import script from "./TextInformationBox.vue?vue&type=script&lang=ts"
export * from "./TextInformationBox.vue?vue&type=script&lang=ts"
import style0 from "./TextInformationBox.vue?vue&type=style&index=0&id=c6e9a0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e9a0a8",
  null
  
)

export default component.exports